import { Injectable } from '@angular/core';
import { ApiService } from '../../core/services/api.service';

@Injectable()
export class Z16ProSectionService {

    constructor (
        private apiService: ApiService
    ) { }

    deleteSection(sectionId: string) {
        return this.apiService.delete(`z16pro/sections/${sectionId}`);
    }

}
